export default "__VITE_ASSET__vtzvxJUM1w5hN9mpTI7UHA__"